export default "__VITE_ASSET__DC7S9_e3__"